export enum DistributorLevel{
    // Distributor = "Distributor"
    AssistantSupervisor = "Assistant Supervisor"
    ,Supervisor = "Supervisor"
    ,AssistantManager = "Assistant Manager"
    ,UnrecognizedManager = "Unrecognized Manager"
    ,RecognizedManager = "Recognized Manager"
    ,SeniorManager = "Senior Manager"
    ,SoaringManager = "Soaring Manager"
    ,SapphireManager = "Sapphire Manager"
    ,DiamondManager = "Diamond Manager"
    ,DoubleDiamondManager = "Double Diamond Manager"
    ,TripleDiamondManager = "Triple Diamond Manager"
    ,DiamondCenturionManager = "Diamond Centurion Manager"
    ,NovusCustomer = "Novus Customer"
    ,DiamondSapphireManager = "Diamond Sapphire Manager"
    ,PreferredCustomer = "Preferred Customer"
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/distributor-level.enum.ts